import * as React from "react";
import Dashboard from "./dashboard/dashboard.component";
import Login from "./login/login.component";
import useStyles from "./styles.app";
import authNetwork from "../../services/network/auth.network";

const App: React.FC = () => {
  const styles = useStyles();

  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      const isExpired: boolean = await authNetwork.refreshToken();
      setIsAuthenticated(!isExpired);
    })();
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1>Welcome to SignIt</h1>
        <p>Save time by signing or sending documents for signature</p>
      </div>
      {isAuthenticated ? (
        <Dashboard authenticator={() => setIsAuthenticated(false)} />
      ) : (
        <Login authenticator={() => setIsAuthenticated(true)} />
      )}
    </div>
  );
};

export default App;
